/**
 * Utilidades para el manejo de tarifas
 */

/**
 * Parsea un string de rango (ej: "[1-100]") a un objeto con min y max
 * @param {string} s - String del rango
 * @returns {{min: number, max: number}} - Objeto con valores min y max
 */
export const parseRange = (s) => {
  if (!s) return { min: 1, max: 100000000 };
  const m = String(s)
    .replace(/[\[\]\s]/g, "")
    .match(/^(\d+)[-.]{1,2}(\d+)$/);
  return m
    ? { min: Number(m[1]), max: Number(m[2]) }
    : { min: 1, max: 100000000 };
};

/**
 * Parsea un texto de tarifas en formato "M:1.5[1-100]|F:2.0[101-500]" a array de objetos
 * @param {string} text - Texto con las tarifas
 * @returns {Array<{type: string, price: number, rangeMin: number, rangeMax: number}>}
 */
export function parseTarifaText(text) {
  if (!text) return [];
  return String(text)
    .split(/[\|\;]+/g)
    .map((x) => x.trim())
    .filter(Boolean)
    .map((chunk) => {
      // 1) FLAT va primero para no confundir con "Fijo"
      const mf = chunk.match(
        /^\s*(FLAT)\s*[-:\s]\s*(\d+(?:\.\d+)?)\s*(?:\[(.*?)\])?/i
      );
      if (mf) {
        const price = Number(mf[2]);
        const { min, max } = parseRange(mf[3]);
        return { type: "FLAT", price, rangeMin: min, rangeMax: max };
      }

      // 2) M/F/B como antes
      const m = chunk.match(
        /^\s*([MFBmfb])\s*[-:\s]\s*(\d+(?:\.\d+)?)\s*(?:\[(.*?)\])?/
      );
      if (!m) return null;
      const type = m[1].toUpperCase(); // 'M'|'F'|'B'
      const price = Number(m[2]);
      const { min, max } = parseRange(m[3]);
      return { type, price, rangeMin: min, rangeMax: max };
    })
    .filter(Boolean);
}

/**
 * Normaliza diferentes formatos de tarifas a un array consistente
 * @param {string|Array|Object} payload - Tarifas en cualquier formato
 * @returns {Array<{type: string, price: number, rangeMin: number, rangeMax: number}>}
 */
export function normalizeTarifas(payload) {
  if (Array.isArray(payload)) return payload;
  if (typeof payload === "string") return parseTarifaText(payload);
  if (
    payload &&
    (payload.M || payload.F || payload.B || payload.FLAT || payload.flat)
  ) {
    return [
      ...parseTarifaText(payload.M || ""),
      ...parseTarifaText(payload.F || ""),
      ...parseTarifaText(payload.B || ""),
      ...parseTarifaText(payload.FLAT || payload.flat || ""),
    ];
  }
  return [];
}
